import React, { useCallback, useState } from "react";
import dayjs from "dayjs";
import { useIntl } from "react-intl";

import { DashboardAction, DataModalCalendarProps, DataModalProps, MotorData } from "../types/types";

import { ModalDetailMyMotor, ModalTailwindCalendar } from "./modals";
import { motorMessages } from "../messages";
import {useTheme} from "styled-components";

export const MyMotor = ({ myMotor, bestSelling }: MotorData) => {
  const [dataModal, setDataModal] = useState<DataModalProps | undefined>(undefined);
  const [dataModalCalendar, setDataModalCalendar] = useState<DataModalCalendarProps | undefined>(
    undefined
  );

  const intl = useIntl();
const theme = useTheme();
  const handleClick = useCallback(
    ({
      action,
      value,
      key,
    }: {
      action: string;
      value: string | number | boolean | undefined;
      key: string;
    }): void => {
      if (action && value && key) {
        const defineAction: any = {
          [DashboardAction.SHOW_MODAL]: () => {
            setDataModal({
              title: key,
              description: `${key}Description`,
              value: value,
              ranking: bestSelling ? bestSelling[`${key}List`] : [],
            });
          },
          [DashboardAction.OPEN_URL]: () => {
            window.open(value ? value.toString() : "https://www.google.com/", "_blank");
          },
          [DashboardAction.SHOW_CALENDAR]: () => {
            setDataModalCalendar({
              title: key,
              notAvailableDates: value ? [dayjs(value.toString()).toDate()] : [],
            });
          },
        };
        const doAction = defineAction[action];
        doAction();
      }
    },
    [bestSelling]
  );

  const closeModal = useCallback(() => {
    setDataModal(undefined);
  }, []);

  const closeModalCalendar = useCallback(() => {
    setDataModalCalendar(undefined);
  }, []);

  return (
    <section className="border rounded border-gray-[#EAEBED] h-full max-h-full overflow-auto">
      <header className="text-[18px] font-semibold m-4">
        {intl.formatMessage(motorMessages.myEngine)}
        <span className="text-xs font-normal text-[#979CB1] pl-2">
          {intl.formatMessage(motorMessages.lastDays)}
        </span>
      </header>
      {myMotor &&
        Object.keys(myMotor).length &&
        Object.keys(myMotor).map((key: string) => {
          const data = myMotor[key];
          return (
            <div key={key}>
              {dataModal && (
                <ModalDetailMyMotor
                  title={intl.formatMessage(motorMessages[dataModal.title])}
                  description={intl.formatMessage(motorMessages[dataModal.description])}
                  value={dataModal.value}
                  ranking={dataModal.ranking}
                  handleClose={closeModal}
                  intl={intl}
                />
              )}
              {dataModalCalendar && (
                <ModalTailwindCalendar
                  title={intl.formatMessage(motorMessages[dataModalCalendar.title])}
                  handleClose={closeModalCalendar}
                  selectedDays={dataModalCalendar.notAvailableDates || []}
                />
              )}
              <article className="flex flex-column px-4 py-[12px] bg-[#F1F5FF] mx-4 my-2.5 rounded min-h-[76px]">
                <span className="text-xs text-[12px] leading-[18px]">
                  {intl.formatMessage(motorMessages[key])}
                </span>
                <span className="text-sm font-semibold">{data?.description || "-"}</span>
                <span
                  onClick={() => handleClick({ action: data?.action, value: data?.value, key })}
                  className={`text-[${theme.buttonColor}] text-[12px] font-semibold  text-left leading-[18px] mt-[12px] ${
                    data?.value && "hover:underline cursor-pointer"}
                  `}>
                  {intl.formatMessage(motorMessages.seeDetails)}
                </span>
              </article>
            </div>
          );
        })}
    </section>
  );
};
